export default "__VITE_ASSET__Bpt2ZWtm__"